import React, { useEffect, useState, useRef } from 'react';
import { baseURL, sistemaURL } from '../url.js';
import '../../css/Components/Products/Products.css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faStar } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda.js';
import { useMediaQuery } from '@react-hook/media-query';
import { renderNumero } from '../../js/funcionesGenerales.js';
export default function Products() {
    const [loading, setLoading] = useState(true);
    const [productos, setProductos] = useState([]);
    const isScreenLarge = useMediaQuery('(min-width: 900px)');

    const [productosPorFamilia, setProductosPorFamilia] = useState([])
    const getProductosPorFamiliaHabilitada = () => {
        fetch(`${sistemaURL}/web/getArticulosPorFamiliaHabilitada`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                //spliteando el arreglo por familia
                const articulosPorFamilia = data.reduce((acumulador, articulo) => {
                    const familia = articulo.nombre_familia;
                    if (!acumulador[familia]) {
                        acumulador[familia] = [];
                    }
                    acumulador[familia].push(articulo);
                    return acumulador;
                }, {});
                //console.log("dataF", articulosPorFamilia)
                setProductosPorFamilia(articulosPorFamilia)
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    }

    useEffect(() => {
        cargarProductos();
        getProductosPorFamiliaHabilitada()

    }, []);



    const cargarProductos = () => {
        fetch(`${sistemaURL}/web/getRecienAgregados?l=10`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const obtenerImagen = (item) => {
        return `${sistemaURL}assets/images/imagenesArticulos/${item.imagen || "sinimagen.jpg"}`
    };
    const obtenerImagenes = (item) => {
        const imagenes = [];
        item.imagenes?.map((imagen) => {
            //imagenes.push(imagen)
            imagenes.push(`${sistemaURL}assets/images/imagenesArticulos/${imagen || "sinimagen.jpg"}`)
        })
        if (imagenes.length == 0) {
            imagenes.push(`${sistemaURL}assets/images/imagenesArticulos/sinimagen.jpg`)
        }
        return imagenes;
    };
    function capitalizarPrimeraLetra(cadena = "") { return cadena.charAt(0).toUpperCase() + cadena.slice(1).toLowerCase(); }

    return (
        <div className='ProductsContain' >
            {loading ? (
                <ProductosLoading />
            ) : (
                <div className='Products'>
                    <div class="categoriasInputs ">

                        {Object.keys(productosPorFamilia)?.slice(0, 7).map((nombre_familia, ind) => (
                            // <h5>{nombre_familia}</h5>
                            <a type="button" href={`#fam_${nombre_familia}`} className="btn btn-sm boton" style={{ borderBottom: "none", maxWidth: "14.4%" }} >{capitalizarPrimeraLetra(nombre_familia)}</a>
                        ))}
                        {/* <input type="button" classname="btn btn-primary" value="Todo" style={{ backgroundColor: "var(--color1)", color: "rgb(255, 255, 255)", borderBottom: "2px solid rgb(12, 113, 207)" }} /> */}

                    </div>

                    <div className='categoriSection'>
                        <div className='deFlexTitlesection'>
                            <h3>Recién agregados</h3>
                            {/* <Anchor to={'/productos'} >
                                Ver más   <FontAwesomeIcon icon={faAngleDoubleRight} />
                            </Anchor> */}
                        </div>
                        <Swiper
                            //modules={[Navigation, Pagination, ]}
                            modules={[Navigation, Pagination, Autoplay]}
                            //effect="coverflow"
                            //grabCursor={true}
                            //slidesPerView="auto"
                            autoplay={{ delay: 3000 }}
                            //effect={'coverflow'}
                            grabCursor={true}
                            slidesPerView={'auto'}
                            //id='cardsProdcutRecienAgregado'
                            id="swiper_container_products"

                        >
                            {productos?.map(item => (
                                <SwiperSlide key={item.id} id='SwiperSlide-scroll-products-masvendidos'>
                                    <Anchor className='cardProdcutmasVendido' to={`/producto/${item.id}/${item.nombre.replace(/\s+/g, '-')}`}>

                                        {/* <img src={obtenerImagen(item)} alt="imagen" /> */}
                                        <Swiper
                                            autoplay={{ delay: 2500 }}
                                            modules={[Navigation, Pagination, Autoplay]}
                                            grabCursor={true}
                                            slidesPerView={'auto'}
                                        >
                                            {obtenerImagenes(item).map((imagen, index) => (
                                                <SwiperSlide key={index}>
                                                    <img src={imagen} alt={`Imagen ${index + 1}`} />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                        <div className='cardText'>
                                            <h4>{item.nombre}</h4>
                                            <div className='deFLexPrice'>
                                                <h5>{moneda} {String(item?.precio_unitario_soles)}</h5>
                                            </div>
                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard2' />
                                        </div>
                                    </Anchor>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    {Object.keys(productosPorFamilia)?.map((nombre_familia, ind) => (
                        // <div key={id_familia} className='categoriSection' ref={ref => categoriasRefs.current[categorias.findIndex(cat => cat.id_familia === id_familia)] = ref}>
                        <div key={ind} className='categoriSection' id={`fam_${nombre_familia}`} >
                            <div className='deFlexTitlesection'>
                                <h3>{nombre_familia}</h3>
                                {/* <Anchor to={'/productos'} >
                                    Ver más   <FontAwesomeIcon icon={faAngleDoubleRight} />
                                </Anchor> */}
                                <Anchor to={'/categoria/' + nombre_familia} >
                                    Ver más   <FontAwesomeIcon icon={faAngleDoubleRight} />
                                </Anchor>
                            </div>

                            <Swiper
                                effect={'coverflow'}
                                grabCursor={true}
                                slidesPerView={'auto'}
                                id='swiper_container_products'
                            >


                                {productosPorFamilia[nombre_familia]?.map(item => (
                                    <SwiperSlide id='SwiperSlide-scroll-products-masvendidos' key={item.id}>
                                        <Anchor className='cardProdcutmasVendido' key={item.id} to={`/producto/${item.id}/${item.nombre.replace(/\s+/g, '-')}`}>

                                            <img src={obtenerImagen(item)} alt="imagen" />
                                            {/* <Swiper
                                                autoplay={{ delay: 2500 }}
                                                modules={[Navigation, Pagination, Autoplay]}
                                                grabCursor={true}
                                                slidesPerView={'auto'}
                                            >
                                                {obtenerImagenes(item).map((imagen, index) => (
                                                    <SwiperSlide key={index}>
                                                        <img src={imagen} alt={`Imagen ${index + 1}`} />
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper> */}
                                            <div className='cardText'>
                                                <h4>{item.nombre}</h4>
                                                <span>{item.descripcion}</span>
                                                <div className='deFLexPrice'>
                                                    <h5> {moneda} {renderNumero(item?.precio_unitario_soles)}</h5>
                                                    {/* {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    )} */}
                                                </div>
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>

                                        </Anchor>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                        </div>

                    ))}


                </div>
            )}
        </div>
    );
}
